import { uniqueIdentifierForNode } from '@ctw/shared/content/document-viewer/_internal/renderers/helpers';
import { View } from '@react-pdf/renderer';
import { isEmpty, trim } from 'lodash-es';
import type { CdaSection } from '../../parsers/types';
import { styles } from './pdf-cda-renderer';
import { PdfNodeRenderer } from './pdf-node-renderer';

interface PdfHtmlRendererProps {
  section: CdaSection;
  html: string;
}

export const PdfHtmlRenderer = ({ section, html }: PdfHtmlRendererProps) => {
  // DOM Parser can't handle multiple root nodes
  const doc = new DOMParser().parseFromString(`<div>${html}</div>`, 'application/xml');
  const nodes = doc.children[0].childNodes;

  return (
    <View style={styles.container}>
      {Array.from(nodes)
        .map((node) => {
          if (!isEmpty(trim(node.textContent ?? ''))) {
            return (
              <PdfNodeRenderer
                key={uniqueIdentifierForNode({ section, node, context: 'node-html-child' })}
                section={section}
                node={node}
              />
            );
          }
          return undefined;
        })
        .filter(Boolean)}
    </View>
  );
};
